import { render } from "./AttributionWindowOdaxBlock.vue?vue&type=template&id=db18ccba"
import script from "./AttributionWindowOdaxBlock.vue?vue&type=script&lang=js"
export * from "./AttributionWindowOdaxBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/RuleForm/Blocks/AttributionWindowOdaxBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "db18ccba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('db18ccba', __exports__)) {
    api.reload('db18ccba', __exports__)
  }
  
  module.hot.accept("./AttributionWindowOdaxBlock.vue?vue&type=template&id=db18ccba", () => {
    api.rerender('db18ccba', render)
  })

}


export default __exports__